import type { CompanyReviewPublicDoc } from "@/types/companyReview";

/**
 * Newest public-facing review date first (YYYY-MM-DD string compare),
 * then newest submission time when the calendar date matches.
 */
export function compareApprovedReviewsByReviewDate(
	a: CompanyReviewPublicDoc,
	b: CompanyReviewPublicDoc,
): number {
	const ymd = (d: CompanyReviewPublicDoc) =>
		d.reviewDate && /^\d{4}-\d{2}-\d{2}$/.test(d.reviewDate)
			? d.reviewDate
			: d.createdAt && d.createdAt.length >= 10
				? d.createdAt.slice(0, 10)
				: "";
	const da = ymd(a);
	const db = ymd(b);
	if (da !== db) return db.localeCompare(da);
	const ta = a.createdAt ? Date.parse(a.createdAt) : 0;
	const tb = b.createdAt ? Date.parse(b.createdAt) : 0;
	return tb - ta;
}
